import {cloneDeep} from 'lodash';

export const updateItem = (ordersProcessedData, payload, unqueKey) => {
  const indexObject = ordersProcessedData.findIndex(
    (odr) => odr[unqueKey] === payload[unqueKey]
  );
  if (indexObject !== -1) {
    const newOrdersProcessedData = cloneDeep(ordersProcessedData);
    Object.assign(newOrdersProcessedData[indexObject], payload);
    newOrdersProcessedData.sort((a, b) => (a[unqueKey] > b[unqueKey] ? 1 : -1));
    return newOrdersProcessedData;
  }
  return ordersProcessedData;
};

export const isEmptyOrder = (tempOrder) => {
  const lastItem = {...tempOrder};
  delete lastItem.id;
  delete lastItem.orderNumber;
  delete lastItem.avaliableColors;
  const lastItemList = Object.values({...lastItem});
  for (let i = 0; i < lastItemList.length; i++) {
    if (lastItemList[i] !== '' && lastItemList[i] !== 0) {
      return false;
    }
  }
  return true;
};

export const isLastTtemEmpty = (tempOrders) => {
  const lastItem = {...tempOrders[tempOrders.length - 1]};
  delete lastItem.id;
  delete lastItem.orderNumber;
  delete lastItem.avaliableColors;
  const lastItemList = Object.values({...lastItem});
  for (let i = 0; i < lastItemList.length; i++) {
    if (lastItemList[i] !== '' && lastItemList[i] !== 0) {
      return false;
    }
  }
  return true;
};

export const isAlLeastOneItem = (tempOrders) => {
  return tempOrders.length > 1 ? true : false;
};
